import { Component, OnInit } from '@angular/core';
import { E5coreUiSearchResultsBaseComponent } from './e5core-ui-search-results-base';

@Component({
  selector: 'e5core-ui-search-results-bootstrap',
  templateUrl: './e5core-ui-search-results-bootstrap.component.html',
  styleUrls: ['./e5core-ui-search-results-bootstrap.component.css']
})
export class E5coreUiSearchResultsBootstrapComponent extends E5coreUiSearchResultsBaseComponent implements OnInit {

  ngOnInit() {
  }

}
